<template>
  <Row class="news-wrap">
    <Col span="24">
      <!-- 标题区域 -->
      <div class="news-header">
        <div class="en-title">NEWS AND INFORMATION</div>
        <div class="line-blue"></div>
        <h2 class="cn-title">新闻中心</h2>
      </div>
    </Col>

    <Col span="24">
      <div class="news-container">
        <ul class="news-list">
          <li
            v-for="(item, index) in NewsData"
            :key="index"
            class="news-item"
            @click="getLocal(item.id)"
          >
            <!-- 左侧图片 -->
            <div class="news-img-box">
              <img :src="item.fileUrls" alt="暂无照片" />
            </div>
            <!-- 右侧内容区 -->
            <div class="news-content">
              <div class="date-block">
                <span class="year">{{ item.publishDate | formatDate }}</span>
                <span class="day">{{ item.publishDate | formatDates }}</span>
              </div>
              <div class="text-block">
                <h3 class="news-title">{{ item.title }}</h3>
                <p class="news-desc">{{ item.subTitle }}</p>
              </div>
            </div>
          </li>
        </ul>

        <Page
          :total="total"
          :page-size="page.size"
          @on-change="changepage"
          @on-page-size-change="_nowPageSize"
          show-total
          class="news-page"
        />
      </div>
    </Col>
  </Row>
</template>

<script>
import { formatDate } from "@/utils/filters";
export default {
  filters: {
    formatDate(time) {
      if (!time) return "";
      const date = new Date(time);
      return formatDate(date, "yyyy");
    },
    formatDates(time) {
      if (!time) return "";
      const date = new Date(time);
      return formatDate(date, "MM‑dd");
    },
  },
  name: "NewsProfile",
  data() {
    return {
      page: {
        page: 1,
        size: 6,
      },
      total: 0,
      NewsData: [],
    };
  },
  mounted() {
    this.getContentByPages();
  },
  methods: {
    getContentByPages() {
      this.$axios
        .get("/api/preHandleCtrl/getContentByPages", {
          params: {
            page: this.page.page,
            size: this.page.size,
            categoryId: 1,
          },
        })
        .then((res) => {
          this.NewsData = res.data.data.resultData || [];
          this.total = res.data.data.totalElement || 0;
        });
    },
    getLocal(id) {
      this.$router.push({
        name: "NewsDetails",
        query: { id },
      });
    },
    changepage(page) {
      this.page.page = page;
      this.getContentByPages();
    },
    _nowPageSize(val) {
      this.page.size = val;
      this.page.page = 1;
      this.getContentByPages();
    },
  },
};
</script>

<style scoped>
.news-wrap {
  max-width: 1400px;
  margin: 0 auto;
  padding: 60px 20px;
}
/* 头部标题 */
.news-header {
  margin-bottom: 50px;
}
.en-title {
  font-size: 26px;
  color: #cccccc;
  font-family: Arial, sans‑serif;
  margin-bottom: 12px;
}
.line-blue {
  width: 80px;
  height: 4px;
  background-color: #1966ff;
  margin-bottom: 12px;
}
.cn-title {
  font-size: 32px;
  font-weight: 700;
  color: #2a2a2a;
  margin: 0;
}

/* 新闻列表容器 */
.news-container {
  width: 100%;
}
.news-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.news-item {
  display: flex;
  align-items: center;
  gap: 30px;
  padding: 24px;
  border: 1px solid #eee;
  border-radius: 12px;
  margin-bottom: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
}
.news-item:hover {
  box-shadow: 0 8px 24px rgba(25, 102, 255, 0.12);
  border-color: #1966ff33;
}

/* 图片容器 */
.news-img-box {
  width: 180px;
  height: 135px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}
.news-img-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}
.news-item:hover .news-img-box img {
  transform: scale(1.08);
}

/* 右侧内容区域 */
.news-content {
  flex: 1;
  display: flex;
  gap: 24px;
}
.date-block {
  min-width: 80px;
  text-align: center;
}
.year {
  display: block;
  font-size: 32px;
  font-weight: bold;
  color: #2a2a2a;
  line-height: 1;
}
.day {
  font-size: 14px;
  color: #888;
  margin-top: 8px;
}
.text-block {
  flex: 1;
}
.news-title {
  font-size: 18px;
  font-weight: bold;
  color: #2a2a2a;
  margin: 0 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.news-item:hover .news-title {
  color: #1966ff;
}
.news-desc {
  font-size: 15px;
  color: #777;
  line-height: 1.7;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* 分页 */
.news-page {
  margin-top: 40px;
  text-align: center;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .news-item {
    flex-direction: column;
    gap: 16px;
    padding: 16px;
  }
  .news-img-box {
    width: 100%;
    height: 200px;
  }
  .news-content {
    flex-direction: column;
    gap: 10px;
  }
  .date-block {
    text-align: left;
  }
  .year {
    font-size: 24px;
  }
  .en-title {
    font-size: 20px;
  }
  .cn-title {
    font-size: 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/News/NewsProfile.vue